import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { invoke } from '../../../internal/utils/invoke';
import { DropdownPopover } from '../../../popover';
import { DateInputInput } from '../../internal/components/DateInputInput';
import { CalendarPicker } from '../../internal/components/CalendarPicker';
import { useDateLimitValue } from '../../internal/hooks';
import { useTimeout } from '../../../internal/hooks';
import { formatDateValueToHTML } from '../../internal/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var DateInputDesktop = /*#__PURE__*/React.forwardRef(function DateInputDesktop(props, ref) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var inputRootRef = React.useRef(null);
  var handleRef = useForkRef(ref, inputRootRef);
  var maskInputRef = React.useRef(null);
  var handleMaskInputRef = useForkRef(maskInputRef, props.maskInputRef);
  var dropdownFocusedRef = React.useRef(false);
  var min = useDateLimitValue(props.min);
  var max = useDateLimitValue(props.max);
  var inputFocusTimeout = useTimeout();
  var inputBlurTimeout = useTimeout();
  var dropdownBlurTimeout = useTimeout();
  var openDropdown = function openDropdown() {
    if (props.readOnly || props.disabled) {
      return;
    }
    setOpen(true);
  };
  var closeDropdown = function closeDropdown() {
    setOpen(false);
  };
  var handleInputClick = function handleInputClick(e) {
    invoke(props.onClick, e);
    if (!e.defaultPrevented) {
      openDropdown();
    }
  };
  var handleInputFocus = function handleInputFocus(e) {
    e.persist();
    dropdownBlurTimeout.clear();
    inputFocusTimeout.set(function () {
      var dropdownHaveFocused = dropdownFocusedRef.current;
      dropdownFocusedRef.current = false;
      openDropdown();
      if (!dropdownHaveFocused) {
        invoke(props.onFocus, e);
      }
    }, 0);
  };
  var handleInputBlur = function handleInputBlur(e) {
    e.persist();
    inputBlurTimeout.set(function () {
      if (dropdownFocusedRef.current) {
        return;
      }
      closeDropdown();
      invoke(props.onBlur, e);
    }, 0);
  };
  var handleDropdownFocused = function handleDropdownFocused(e) {
    e.preventDefault();
    dropdownFocusedRef.current = true;
    var input = maskInputRef.current;
    input === null || input === void 0 || input.focus();
  };
  var handleDropdownBlur = function handleDropdownBlur() {
    dropdownBlurTimeout.set(function () {
      dropdownFocusedRef.current = false;
      // Вызываем чуть позже, чтобы обработать фокус на инпуте первым
    }, 10);
  };
  var handleChange = function handleChange(nextDate) {
    if (formatDateValueToHTML(props.value) !== formatDateValueToHTML(nextDate)) {
      invoke(props.onChange, nextDate);
    }
    closeDropdown();
  };
  return /*#__PURE__*/_jsx(DropdownPopover, {
    open: open,
    sameWidth: false,
    content: /*#__PURE__*/_jsx("div", {
      tabIndex: 0,
      onFocus: handleDropdownFocused,
      onBlur: handleDropdownBlur,
      children: /*#__PURE__*/_jsx(CalendarPicker, {
        selected: props.value || null,
        onChange: handleChange,
        min: min,
        max: max
      })
    }),
    children: /*#__PURE__*/_jsx(DateInputInput, _objectSpread(_objectSpread({}, props), {}, {
      ref: handleRef,
      onFocus: handleInputFocus,
      onBlur: handleInputBlur,
      onClick: handleInputClick,
      maskInputRef: handleMaskInputRef,
      min: min,
      max: max
    }))
  });
});